import React, { FC, useEffect } from "react";

export type CaCheckboxProps = {
  checked: boolean;
  id?: string;
  name?: string;
  disabled?: boolean;
  value: any;
  onChange?: (checked: boolean, value: any) => void;
  label?: string;
};

const CaCheckbox: FC<CaCheckboxProps> = ({
  checked,
  id,
  name,
  disabled,
  value,
  onChange,
  label,
}) => {
  const [checkedState, setCheckedState] = React.useState(checked);

  useEffect(() => {
    setCheckedState(checked);
  }, [checked]);

  return (
    <div className='flex items-center'>
      <input
        id={id}
        name={name}
        type='checkbox'
        className='cursor-pointer w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500  focus:ring-2'
        checked={checkedState}
        disabled={disabled}
        onClick={() => {
          console.log(value);
          setCheckedState(!checkedState);
          onChange && onChange(!checkedState, value);
        }}
      />
      {label && (
        <label htmlFor={id} className='ms-2 text-sm font-medium cursor-pointer'>
          {label}
        </label>
      )}
    </div>
  );
};

export default CaCheckbox;
